import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import styled from "styled-components";

import "swiper/components/navigation/navigation.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import { ArrowLeftColor, TitlePage } from "@components";
import { PATH_BMIFORM, PATH_BMIHISTORY } from "@configs";
import { selectAuth, selectMerchant } from "@redux";
import { RenderMeta } from "@utils";
import { useEffect, useState } from "react";
import { useFullScreen } from "src/Helpers/useFullscreen";
import { BoxBmiResult } from "./shared/BoxBmiResult";

interface Product {
    name: string;
    description: string;
    url: string;
    image_url: string;
    price?: string;
    discounted_price?: string;
}

interface ProductGroup {
    product_group_name: string;
    products: Product[];
}

interface ProductGroupsProps {
    data: ProductGroup[];
}

export const ComponentBmiResult = () => {
    const location = useLocation();
    const formData = location.state as any;

    const { t } = useTranslation();
    const history = useHistory();
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);

    const [viewportHeight, setViewportHeight] = useState(0);
    const dispatch = useDispatch();
    const fullHeight = useFullScreen();

    // Now receiving pre-calculated data from BmiForm
    const weight = formData?.weight || 0;
    const height = formData?.height || 0;
    const age = formData?.age || 0;
    const gender = formData?.gender || "Female";
    const goalText = formData?.goalText || "Weight Loss";

    // Pre-calculated values from BmiForm
    const bmiResult = {
        bmi: formData?.bmi?.toFixed(2) || "0.00",
        weight,
        height,
        age,
        gender,
    };

    const resultNutrition = {
        calories: formData?.calories || 0,
        protein: formData?.protein || 0,
        carbohydrates: formData?.carbohydrates || 0,
        fat: formData?.fat || 0,
        sugar: formData?.sugar || 0,
        saturatedFat: formData?.saturatedFat || 0,
    };

    const bmiStatus = formData?.bmiStatus || "Normal";

    useEffect(() => {
        setViewportHeight(window.innerHeight);
    }, []);

    const productData = {
        code: 0,
        data: [
            {
                product_group_name: "Lean & burn",
                products: [
                    {
                        name: "OOLONG TEA+ Plus",
                        description: "Burn fat with Oolong Tea",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-01.svg",
                    },
                    {
                        name: "BRAND",
                        description: "High-quality brand product",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-02.svg",
                    },
                    {
                        name: "OOLONG TEA+ Plus",
                        description: "Burn fat with Oolong Tea",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-01.svg",
                    },
                    {
                        name: "BRAND",
                        description: "High-quality brand product",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-02.svg",
                    },
                ],
            },
            {
                product_group_name: "High Protein",
                products: [
                    {
                        name: "Suntory Sesamin EX 90",
                        description: "Protein-packed supplement",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-03.svg",
                    },
                    {
                        name: "Suntory Sesamin EX 90",
                        description: "Maintain health with Sesamin",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-04.svg",
                    },
                    {
                        name: "Suntory Sesamin EX 90",
                        description: "Protein-packed supplement",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-03.svg",
                    },
                    {
                        name: "Suntory Sesamin EX 90",
                        description: "Maintain health with Sesamin",
                        url: "https://manager.line.biz/invitation/BhlrPT9fInj5gpGNWnjXDk1tgIp9if",
                        image_url: "../../images/img-product-bmi-04.svg",
                    },
                ],
            },
        ],
        message: "",
    };

    function ProductGroups({ data }: ProductGroupsProps) {
        return (
            <div>
                {data.map((group, groupIndex) => (
                    <div className="group-product-bmi" key={groupIndex}>
                        <div className="title-group-product">
                            {group.product_group_name} <span>All {group.products.length}</span>
                        </div>
                        <Swiper slidesPerView={2.5} spaceBetween={10} pagination={false}>
                            {group.products.map((product, productIndex) => (
                                <SwiperSlide key={productIndex}>
                                    <div
                                        className="list-product-bmi"
                                        onClick={() => (window.location.href = product.url)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="img-product-bmi">
                                            <img src={product.image_url} alt={product.name} />
                                        </div>
                                        <div className="name-product-bmi">{product.name}</div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                ))}
            </div>
        );
    }

    return (
        <>
            <RenderMeta title="BMI RESULT" />
            <StyledBmiResult
                style={{ height: fullHeight }}
                themeColor={themes?.themeColor!}
                bgImg="../../images/bg-calculator.svg"
                contentColor={merchant?.luckyDrawDisplaySetting?.textColor!}
                themePageColor="#76C0D9"
            >
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor onClick={() => history.push(PATH_BMIFORM)} color="white" />
                    </div>
                    <div className="header-title">
                        <TitlePage text="CALCULATOR" />
                    </div>
                    <div className="icon-history" onClick={() => history.push(PATH_BMIHISTORY)}>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M10.5 22H6.00003C4.34316 22 3.00001 20.6568 3.00003 19L3.00014 4.99998C3.00016 3.34313 4.3433 2 6.00014 2H16C17.6569 2 19 3.34315 19 5V10.5"
                                stroke={"white"}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M7 7H15M7 11H11"
                                stroke={"white"}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M18 18.5L16.5 17.95V15.5M12 17.5C12 19.9853 14.0147 22 16.5 22C18.9853 22 21 19.9853 21 17.5C21 15.0147 18.9853 13 16.5 13C14.0147 13 12 15.0147 12 17.5Z"
                                stroke={"white"}
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </div>
                </header>
                <div className="wrapper-bmi-result">
                    <div className="title-sub-bmi-result">Your BMI</div>
                    <div className="wrapper-detail-user-bmi">
                        <div className="box-detail-user-bmi">
                            <div className="img-user-bmi">
                                <img
                                    src={userInfo?.avatar || "../images/img-profile-default-01.png"}
                                    alt=""
                                />
                            </div>
                            <div className="name-user-bmi">{userInfo?.fullName}</div>
                            <div className="content-user-bmi">
                                <div className="layout-user-bmi">
                                    <span>Weight: {bmiResult.weight} KG</span>
                                    <span>Height: {bmiResult.height} CM</span>
                                </div>
                                <div className="layout-user-bmi">
                                    <span>Age: {age}</span>
                                    <span>Gender: {gender === "male" ? "Male" : "Female"}</span>
                                </div>

                                <div className="activity-user-bmi">
                                    <span>
                                        <img src="../../images/img-activity-bmi-01.svg" alt="" />
                                    </span>
                                    <span>
                                        <img src="../../images/img-activity-bmi-02.svg" alt="" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="detail-bmi-result">
                        <div className="score-bmi">
                            <div className="title-score-bmi">Your BMI SCORE</div>
                            <div className="result-score-bmi">
                                {bmiResult.bmi}
                                <span>{bmiStatus}</span>
                            </div>
                        </div>
                        <div className="improve-bmi-result">
                            <div className="title-imporve">
                                <span>Improve</span> <span>{goalText}</span>
                            </div>
                            <div className="wrapper-box-bmi-result">
                                <BoxBmiResult
                                    title="Calories"
                                    result={resultNutrition.calories}
                                    perday="Per day"
                                    isBorder={true}
                                    colorText="#000"
                                    bgColor="#fff"
                                />
                                <BoxBmiResult
                                    title="Protein"
                                    result={resultNutrition.protein}
                                    perday="g/day"
                                    colorText="#fff"
                                    bgColor="#68a9bf"
                                />
                                <BoxBmiResult
                                    title="Carbohydrates"
                                    result={resultNutrition.carbohydrates}
                                    perday="g/day"
                                    colorText="#fff"
                                    bgColor="#76C0D9"
                                />
                                <BoxBmiResult
                                    title="Fat"
                                    result={resultNutrition.fat}
                                    perday="g/day"
                                    colorText="#fff"
                                    bgColor="#76C0D9"
                                />
                                <BoxBmiResult
                                    title="Sugar"
                                    result={resultNutrition.sugar}
                                    perday="g/day"
                                    colorText="#fff"
                                    bgColor="#2a454e"
                                />
                                <BoxBmiResult
                                    title="Saturated Fat"
                                    result={resultNutrition.saturatedFat}
                                    perday="g/day"
                                    colorText="#000"
                                    bgColor="#ebf6fb"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="wrapper-product-bmi">
                        <div className="title-product-bmi">
                            <img src="../../images/ic-suntory.svg" alt="" />
                        </div>
                        <div className="sub-title-product-bmi">Recommendations</div>
                        <ProductGroups data={productData.data} />;
                    </div>
                </div>
            </StyledBmiResult>
        </>
    );
};

const StyledBmiResult = styled.div<{
    themeColor: string;
    bgImg: string;
    contentColor: string;
    themePageColor: string;
}>`
    width: 100%;
    margin: 0 auto;
    height: 100vh;
    overflow: scroll;
    background-color: #76c0d9;
    background-position: center top;
    background-repeat: no-repeat;
    background-image: url("../../images/bg-calculator.svg");
    background-size: 100%;
    position: relative;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .header-title {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .icon-history {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        min-height: 15vh;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .wrapper-bmi-result {
        background-color: #fff;
        padding: 30px 0;
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        .title-sub-bmi-result {
            font-size: 16px;
            line-height: 19px;
            color: #000000;
            font-weight: 600;
            margin-bottom: 8px;
            padding: 0 16px;
        }
        .wrapper-detail-user-bmi {
            padding: 16px;
            .box-detail-user-bmi {
                position: relative;
                padding: 16px;
                background-color: rgba(158, 158, 158, 0.12);
                border-radius: 12px;
                padding-left: 60px;
                padding-right: 150px;
                .img-user-bmi {
                    position: absolute;
                    left: 16px;
                    top: 16px;
                    border-radius: 100%;
                    overflow: hidden;
                    width: 32px;
                    height: 32px;
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                }
                .name-user-bmi {
                    font-size: 14px;
                    line-height: 17px;
                    font-weight: 600;
                    color: #000;
                    margin-bottom: 4px;
                }
                .content-user-bmi {
                    margin-bottom: 4px;
                    .layout-user-bmi {
                        span {
                            display: inline-block;
                            font-size: 10px;
                            line-height: 13px;
                            color: #000;
                            margin-right: 8px;
                            padding-right: 8px;
                        }
                    }
                    .edit-user-bmi {
                        display: inline-block;
                        font-size: 10px;
                        line-height: 13px;
                        color: #76c0d9;
                        margin-right: 8px;
                        padding-right: 8px;
                        margin-top: 6px;
                        cursor: pointer;
                        span {
                            margin-right: 2px;
                            img {
                                width: 12px;
                                height: 12px;
                            }
                        }
                    }
                    .activity-user-bmi {
                        position: absolute;
                        right: 16px;
                        top: 50%;
                        transform: translateY(-50%);
                        span {
                            width: 46px;
                            height: 46px;
                            margin-left: 8px;
                            display: inline-block;
                            img {
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                    }
                }
            }
        }
        .detail-bmi-result {
            padding: 30px 16px;
            background-color: #2a454e;
            border-top-right-radius: 16px;
            border-top-left-radius: 16px;
            .score-bmi {
                padding: 20px 0px 30px;
                display: flex;
                background-image: url(../../images/bg-score-bmi.svg);
                background-repeat: no-repeat;
                background-size: cover;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                background-color: #26c2a4;
                border-radius: 16px;
                margin-bottom: 8px;
                .title-score-bmi {
                    font-size: 16px;
                    line-height: 19px;
                    font-weight: 600;
                    color: #fff;
                    margin-bottom: 16px;
                }
                .result-score-bmi {
                    font-size: 50px;
                    line-height: 55px;
                    font-weight: 600;
                    color: #fff;
                    text-align: center;
                    span {
                        display: block;
                        font-size: 20px;
                        line-height: 23px;
                    }
                }
            }
            .improve-bmi-result {
                padding: 20px;
                background-color: #a5d5e6;
                border-radius: 16px;
                .title-imporve {
                    font-size: 28px;
                    line-height: 31px;
                    color: #000000;
                    font-weight: 600;
                    text-transform: uppercase;
                    margin-bottom: 16px;
                    span {
                        display: block;
                        font-weight: 600;
                    }
                }
                .wrapper-box-bmi-result {
                    display: grid;
                    grid-template-columns: 1fr 1fr 1fr;
                    gap: 8px;
                }
            }
        }
        .wrapper-product-bmi {
            padding: 30px 16px;
            .title-product-bmi {
                text-align: center;
                margin-bottom: 5px;
            }
            .sub-title-product-bmi {
                font-size: 20px;
                line-height: 23px;
                color: #ffc107;
                font-weight: 600;
                margin-bottom: 16px;
                text-align: center;
            }
            .group-product-bmi {
                margin-bottom: 10px;
                .title-group-product {
                    font-size: 16px;
                    line-height: 19px;
                    color: #000;
                    font-weight: 600;
                    margin-bottom: 12px;
                    span {
                        margin-left: 8px;
                        color: #898989;
                        font-size: 12px;
                        line-height: 20px;
                    }
                }
                .list-product-bmi {
                    .img-product-bmi {
                        margin-bottom: 10px;
                        border: 1px solid #f2f2f2;
                        width: 100%;
                        height: 143px;
                        border-radius: 12px;
                        img {
                            width: 100%;
                            height: 100%;
                            object-fit: contain;
                        }
                    }
                    .name-product-bmi {
                        font-size: 12px;
                        line-height: 20px;
                    }
                }
                .swiper-pagination {
                    display: none;
                }
            }
        }
    }
`;
